import { AlertTriangle, CheckCircle2, Clock3 } from "lucide-react";

import { relativeTime } from "@/lib/format";
import type { Story } from "@/lib/types";

function StatusIcon({ story }: { story: Story }) {
  if (story.status === "ready") {
    return <CheckCircle2 aria-label="Ready" className="status-ready" />;
  }
  if (story.status === "conflict") {
    return <AlertTriangle aria-label="Conflict" className="status-conflict" />;
  }
  return <Clock3 aria-label="Needs review" className="status-review" />;
}

export function StoryList({
  stories,
  selectedId,
  onSelect,
}: {
  stories: Story[];
  selectedId: string | null;
  onSelect: (storyId: string) => void;
}) {
  if (stories.length === 0) {
    return (
      <div className="list-empty">
        <RadioEmpty />
        <strong>No stories in this view</strong>
        <span>Press Play or change the status filter.</span>
      </div>
    );
  }

  return (
    <div className="story-list">
      {stories.map((story) => (
        <button
          type="button"
          key={story.id}
          className={`story-row ${selectedId === story.id ? "is-selected" : ""}`}
          onClick={() => onSelect(story.id)}
        >
          <span className="story-row-topline">
            <StatusIcon story={story} />
            <span>{story.source_count} sources</span>
            <span className="dot">·</span>
            <span>{Math.round(story.confidence * 100)}% confidence</span>
            <time>{relativeTime(story.updated_at)}</time>
          </span>
          <strong>{story.headline}</strong>
          <span className="story-row-summary">
            {story.summary || "Evidence collected; summary pending."}
          </span>
        </button>
      ))}
    </div>
  );
}

function RadioEmpty() {
  return (
    <span className="radio-empty" aria-hidden="true">
      <span />
      <span />
      <span />
    </span>
  );
}
